module.exports = __webpack_public_path__ + "img/website-store-tiles-01-4_low_prints.2f774e60.jpeg";